require('./news.module');
require('./controllers/edit.controller');
require('./controllers/view.controller');
require('./controllers/index.controller');
require('./controllers/archive.controller');